import EntityCrudPage from '../../shared/EntityCrudPage';
import { incidentConfig } from '../../config/entityConfigs';

const IncidentsPage = () => <EntityCrudPage config={incidentConfig} />;

export default IncidentsPage;
